import produce from 'immer';
import { array } from '../utils';

const { applyMinimalChangesToArray } = array;

const initialState = produce({ breakRules: [] }, () => {});

const actionResultWithCrewId = (action) =>
  action.result.map((resultItem) => ({ ...resultItem, crewId: action.crewId }));

// Using immer, param-reassign is actually not a problem
/* eslint-disable no-param-reassign */
export const breakRulesReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case 'LOAD_BREAK_RULES_SUCCESS':
        applyMinimalChangesToArray(
          draft.breakRules,
          actionResultWithCrewId(action),
          (breakRule) => breakRule.crewId === action.crewId
        );
        break;
      case 'SIGNOUT_USER_SUCCESS':
        return initialState;
      default:
      // nothing to do => immer returns the same object
    }
  });
